module.exports = __webpack_public_path__ + "img/arrecredi_bdon_2.800d3c21.webp";